export const version = `1.5.1`;
export const versionWithBuild = `1.5.1-1`;
